import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from '../../../material.module';
import { MenuItem } from '@lib/interfaces/menu-items.interface';
import { SettingsService } from '@lib/services/settings/settings.service';
import { environment } from '@env/environment';
import { getlowerMenuItems, getMenuItems } from '@lib/constants/sidemenu.constants';
import { TenantConfigurationService } from '@lib/services';
import { Store } from '@ngrx/store';
import { selectEncryptedTenantKey } from '@store/selectors/tenant.selectors';
import { AppState } from '@store/app.state';
import { Subject, takeUntil } from 'rxjs';
import { ScrollService } from '@lib/services/scroll.service';
import { TenantService } from '@lib/services/tenant.service';
import { PermissionService } from '@lib/services/permission.service';
import { customerTenant } from '@env/environment';

@Component({
    standalone: true,
    imports: [CommonModule, RouterModule, AngularMaterialModule],
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent implements OnDestroy, OnInit {
    @Output() collapseStatusChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    isCollapseNav = false;
    isTenantDropdownOpen = true;
    tenantsList = [
        { tenant: 'NymCard', selected: true },
        { tenant: 'Tenant 1', selected: false },
        { tenant: 'Tenant 2', selected: false },
        { tenant: 'Tenant 3', selected: false },
        { tenant: 'Tenant 4', selected: false },
        { tenant: 'Tenant 5', selected: false },
    ];

    tenantKey = '';
    imgUrl = '';
    logoClass: Record<string, boolean> = {};
    activeTabForTenant0 = ['Call Center', 'Customers', 'Cards', 'Access Management'];
    version = environment.version;
    menuItems: MenuItem[];
    lowerMenuItems: MenuItem[];
    private destroy$ = new Subject<void>(); // Add destroy$ for cleanup
    constructor(private router: Router, public settingService: SettingsService, public tenantConfigurationService: TenantConfigurationService, private store: Store<AppState>, private scrollService: ScrollService, private tenantService: TenantService, private permissionService: PermissionService) {
        this.store
            .select(selectEncryptedTenantKey)
            .pipe(takeUntil(this.destroy$))
            .subscribe((key: string | null) => {
                if (key) {
                    this.tenantKey = this.tenantService.getTenantKey() ?? '';
                    this.activeTabForTenant0 = this.permissionService.isAdministrator() ? ['Call Center', 'Customers', 'Cards', 'Access Management'] : ['Call Center', 'Customers', 'Cards'];
                    this.updateLogoImageUrl();
                    this.menuItems = getMenuItems();
                    this.lowerMenuItems = getlowerMenuItems();
                }
            });
    }
    panelOpenState = false;

    ngOnInit(): void {
        //Live updating the logo image on logo updated
        this.settingService.settingsDetails.subscribe((item) => {
            const { logo_file_name } = item;
            if (logo_file_name && logo_file_name !== 'undefined' && logo_file_name !== 'null') {
                localStorage.setItem('tenantLogo', item.logo_file_name);
                this.updateLogoImageUrl();
            }
        });
    }

    updateLogoImageUrl() {
        const localLogoUrl = localStorage.getItem('tenantLogo');
        const logoUrlFromTenant = this.tenantConfigurationService.getImageSpecificToTenant(this.tenantKey, 'sidenav_logo');
        // pick logo URL in priority order
        this.imgUrl = localLogoUrl || logoUrlFromTenant || '/assets/logo-white.png';

        // decide class based on whether we ended up with a tenant logo or the default
        const isTenantLogo = !!localLogoUrl;
        this.logoClass = {
            'tenant-logo': isTenantLogo,
            'riyadh-logo': this.tenantKey.split('_')[0] === customerTenant.RIYAD,
        };
    }

    ngOnDestroy(): void {
        this.destroy$.next(); // Emit to complete the observable
        this.destroy$.complete(); // Complete the subject
    }

    checkExpandedItem(item: string): boolean {
        return this.router.url.includes(item);
    }

    collapseNav() {
        this.isCollapseNav = true;
        this.collapseStatusChange.emit(this.isCollapseNav);
    }

    unCollapseNav() {
        this.isCollapseNav = false;
        this.collapseStatusChange.emit(this.isCollapseNav);
    }

    toggleCollapseNav() {
        this.isCollapseNav = !this.isCollapseNav;
        this.collapseStatusChange.emit(this.isCollapseNav);
    }

    handleMenuClick(item: MenuItem) {
        if (this.isCollapseNav && item.title === 'Settings') {
            this.router.navigate(['/control-center/settings']);
        }
    }

    handleExpandClick(item: MenuItem, event: MouseEvent) {
        if (this.isCollapseNav && item.title === 'Settings') {
            event.stopPropagation();
            this.router.navigate(['/control-center/settings']);
        }
    }
    toggleTenantDropdown() {
        this.isTenantDropdownOpen = !this.isTenantDropdownOpen;
    }
    selectTenant(selectedTenant: any): void {
        this.tenantsList.forEach((tenant) => {
            tenant.selected = tenant === selectedTenant;
        });
    }
}
